<template>
    <v-container fluid>
        <v-row no-gutters>
            <v-col v-if="agent" cols="2" align="start" class="align-content-center">
                <div>
                    <v-img
                        :src="this.$store.getters.getClientImage"
                        class="rounded-circle mx-auto"
                        max-width="40"
                    />
                </div>
            </v-col>
            <v-col cols="10" align="start" class="ml-auto">
                <div
                    class="white--text rounded-xl px-3 py-3 bubble-text"
                    :class="[agent ? 'grey--text text--darken-4 grey lighten-3 float-left' : 'float-right']"
                    :style="`background-color: ${mainColor}`"
                >
                    {{ reply.message.text }}
                </div>
            </v-col>
        </v-row>
        <v-expand-transition>
            <v-row
                v-if="selection === null && isLastMessage"
                no-gutters
            >
                <v-col :offset="agent ? 2 : 0">
                    <v-chip-group
                        v-model="selection"
                        column
                    >
                        <v-chip
                            v-for="(quick, index) in reply.message.quick_replies"
                            :key="index"
                            small
                            @click="clickButton(quick, quick.title)"
                        >
                            {{ quick.title }}
                        </v-chip>
                    </v-chip-group>
                </v-col>
            </v-row>
        </v-expand-transition>
    </v-container>
</template>

<script>
    export default {
        props: {
            agent: {
                type: Boolean,
                default: false
            },
            reply: {
                type: Object,
            },
            mainColor: {
                type: String,
                default: null
            },
            isLastMessage: {
                type: Boolean,
                default: false
            }
        },
        data: () => ({
            selection: null,
            data: {
                "message":
                {
                    "text": "Pick a color:",
                    "quick_replies":
                    [
                        {
                            "content_type":"text",
                            "title":"Red",
                            "payload":"<POSTBACK_PAYLOAD>",
                            "image_url":"http://example.com/img/red.png"
                        },
                        {
                            "content_type":"text",
                            "title":"Green",
                            "payload":"<POSTBACK_PAYLOAD>",
                            "image_url":"http://example.com/img/green.png"
                        },
                        {
                            "content_type":"text",
                            "title":"Red",
                            "payload":"<POSTBACK_PAYLOAD>",
                            "image_url":"http://example.com/img/red.png"
                        },
                        {
                            "content_type":"text",
                            "title":"Green",
                            "payload":"<POSTBACK_PAYLOAD>",
                            "image_url":"http://example.com/img/green.png"
                        },
                        {
                            "content_type":"text",
                            "title":"Red",
                            "payload":"<POSTBACK_PAYLOAD>",
                            "image_url":"http://example.com/img/red.png"
                        },
                        {
                            "content_type":"text",
                            "title":"Green",
                            "payload":"<POSTBACK_PAYLOAD>",
                            "image_url":"http://example.com/img/green.png"
                        }
                    ]
                }
            }
        }),
        methods: {
            clickButton(button, buttonText) {
                this.$emit('prepareMessage', {
                    text: button.payload,
                    freshchatAgentText: buttonText
                })
            },
        }
    }
</script>

<style scoped>
    .theme--light.v-icon {
        color: v-bind(mainColor) !important;
    }
</style>